import useSWR from "swr"

import {
    AppError,
    parseAndThrowAppError,
} from "../../../../errors/errorProcessors"
import { useGetUserData } from "../../../../hooks/useGetUserData"
import { tsIoValidate } from "../../../../utils/general/generalUtils"
import { getClientProtected } from "../../clients/clients"
import {
    GetOrgRes,
    TGetOrgRes,
} from "../../types/organisation/organisationTypes"
import { GET_MY_ORG } from "../../urls/private"

interface IUseGetMyOrg {
    data: TGetOrgRes | undefined
    isLoading: boolean
    isValidating: boolean
    error: undefined | AppError
    mutate: () => void
}

/**
 * Gets details on a users org
 * @returns {IUseGetMyOrg} - loading and error states.
 */
const useGetMyOrg = (): IUseGetMyOrg => {
    const {
        isSignedIn,
        isInstaller,
        isInstallerAdmin,
        isManuAdmin,
        isManuApproved,
    } = useGetUserData()
    const { data, error, isLoading, isValidating, mutate } = useSWR(
        isSignedIn &&
            (isInstaller || isInstallerAdmin || isManuApproved || isManuAdmin)
            ? GET_MY_ORG
            : null,
        async (url: string): Promise<TGetOrgRes> => {
            try {
                const res = await getClientProtected(url)
                return tsIoValidate<TGetOrgRes>(
                    GetOrgRes,
                    res,
                    "Invalid organisation received from server"
                )
            } catch (err) {
                throw parseAndThrowAppError(err)
            }
        }
    )

    return {
        data,
        isLoading,
        error,
        isValidating,
        mutate,
    }
}

export default useGetMyOrg
